import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

import SvgIcon from "../common/SvgIcon";
import iconSprite from "../../../../images/img/chat/icons.svg";

const HamburgerMenu = ({ isDisabled, onClick }) => {
    const itemClassNames = classNames({
        menu: true,
        disabled: isDisabled,
    });

    return (
        <div className={itemClassNames} onClick={onClick}>
            <SvgIcon src={iconSprite} id="icon-hamburger-menu" />
        </div>
    );
};

HamburgerMenu.propType = {
    isDisabled: PropTypes.bool,
    onClick: PropTypes.func,
};

export default HamburgerMenu;
